( function( $ ) {

  setTimeout(function() {
    $(".facebook-content").append('<div class="fb-page" data-href="https://www.facebook.com/tocadocoelhoonline" data-width="500" data-height="300" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true" data-show-posts="true"><div class="fb-xfbml-parse-ignore"><blockquote cite="https://www.facebook.com/tocadocoelhoonline"><a href="https://www.facebook.com/tocadocoelhoonline">Toca do Coelho</a></blockquote></div></div>');
    FB.XFBML.parse();
  }, 10000);

})( jQuery );
